import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-49" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-50" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-51" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-52" data-mp="57ebob4uv5ec">
            Ein besserer Weg, Mathematik zu unterrichten
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-53" data-mp="3rgp7tzor59g5">
            Von der leeren Unterrichtsplanung zur{' '}
            <span className="italic text-brand" data-id="element-54" data-mp="3ifhbhn5sqiop">sicheren Mathestunde.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-55" data-mp="1bpb4e1tzs67s">
            Jeder Band nimmt dir die Vorbereitung ab — mit fertigen Erklärungen, visuellen
            Beispielen, Übungen, Differenzierungen und Lernstandschecks.
          </p>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-56" data-mp="1j92nqzpzc5w5">
            So kannst du dich auf das Wesentliche konzentrieren:{' '}
            <span className="font-display font-bold italic text-ink" data-id="element-57" data-mp="1szniud6g2sab">
              das Erklären, Begleiten und Unterrichten.
            </span>
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-58" data-mp="10brq1jjzxkit">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-59" data-mp="1aa7j3s2l33uy" data-mpi={index}>
              <dt className="sr-only" data-id="element-60" data-mp="2loutgaj6b8bx">{stat.label}</dt>
              <dd data-id="element-61" data-mp="2lrqn3mnznauk">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-62" data-mp="2gqt9zohu56zx">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-63" data-mp="2oqh4anghb7u1">
                  {stat.label}
                </span>
                {stat.sub && <span className="mt-0.5 block text-[11px] text-ink/45" data-id="element-64" data-mp="2xsyokwckpqee">{stat.sub}</span>}
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-65" data-mp="253jhgho14hnr">
          <div className="grid md:grid-cols-2" data-id="element-66" data-mp="251f5dcfz8cce">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-67" data-mp="2a3e4290rul30">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-68" data-mp="2f1phetq9zdpz">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-69" data-mp="2jsxr7qvip13o" />
              </span>
              <h3 className="font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-70" data-mp="1mbqnol14ysez">
                Vorher
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-71" data-mp="1r9iflf1s6ej6">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-72" data-mp="1jq9d85rozg3m">
                    <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-73" data-mp="19sbiczfbul21" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-74" data-mp="10usvrqm1byo1">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-75" data-mp="w1q8u1brjngt">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-76" data-mp="r1kc46qmzarv" />
              </span>
              <h3 className="font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-77" data-mp="m6eq77x8hw3s">
                Mit <span className="text-brand" data-id="element-78" data-mp="h7blxpp2vtwv">MATHE BEREIT™</span>
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-79" data-mp="d4ozk4b6f172">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-80" data-mp="11v30tq7y32mn">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-81" data-mp="t1pzbzvtesoy" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-82" data-mp="j6elrkw57ris">
            Ein komplettes Mathematik-Curriculum, das deine Vorbereitung auf wenige Minuten
            verkürzt.
          </p>
        </div>
      </div>
    </section>;
}